import React from "react";
import { XMarkIcon } from "@heroicons/react/24/outline";
import { AnimatePresence, motion } from "framer-motion";

const Drawer = ({ open, onClose, title, subtitle, children }) => (
  <AnimatePresence>
    {open && (
      <>
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          onClick={onClose}
          className="fixed inset-0 bg-black/40 z-40"
        />
        <motion.div
          initial={{ x: "100%" }}
          animate={{ x: 0 }}
          exit={{ x: "100%" }}
          transition={{ type: "tween", duration: 0.25 }}
          className="fixed top-0 right-0 h-full w-full sm:w-[480px] bg-white border-l border-gray-200 z-50 overflow-y-auto shadow-xl"
        >
          <div className="sticky top-0 bg-white border-b border-gray-100 p-4 flex items-start justify-between z-10">
            <div>
              <h3 className="text-lg font-semibold text-gray-900">{title}</h3>
              {subtitle && <p className="text-sm text-gray-500">{subtitle}</p>}
            </div>
            <button onClick={onClose} className="p-1.5 rounded-lg text-gray-400 hover:bg-gray-100 hover:text-gray-700">
              <XMarkIcon className="w-5 h-5" />
            </button>
          </div>
          <div className="p-4 space-y-5">{children}</div>
        </motion.div>
      </>
    )}
  </AnimatePresence>
);

export const DrawerSection = ({ label, children }) => (
  <div>
    <p className="text-xs font-semibold text-gray-400 uppercase tracking-wide mb-2">{label}</p>
    <div className="text-sm text-gray-700">{children}</div>
  </div>
);

export const Timeline = ({ items = [] }) => (
  <ol className="relative border-l border-gray-200 ml-2 space-y-4">
    {items.map((it, idx) => (
      <li key={idx} className="ml-4">
        <div className="absolute w-2 h-2 rounded-full bg-blue-500 -left-[4.5px] mt-1.5" />
        <p className="text-xs text-gray-400">{new Date(it.time).toLocaleString()}</p>
        <p className="text-sm text-gray-700">{it.label}</p>
      </li>
    ))}
    {items.length === 0 && <p className="text-sm text-gray-400 ml-4">No timeline events yet.</p>}
  </ol>
);

export default Drawer;
